import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import NotFound from './views/404.vue'
import Login from './views/Login.vue'
import { getUser } from './utils/auth';
import Home from './views/Home.vue'
import UserList from './views/UserList.vue'
import HouseList from './views/HouseList.vue'
import TenantList from './views/TenantList.vue'
import LeaseInfo  from './views/LeaseInfo.vue'
import ContractList  from './views/ContractList.vue'
import OfficeCheckinList from './views/OfficeCheckinList.vue'
import PropertyComplaintList from './views/PropertyComplaintList.vue'
import PropertyRepairList from './views/PropertyRepairList.vue'
import HousingStatistics from './views/HousingStatistics.vue'
import StoreInformation from './views/StoreInformation.vue'
import PropertyManagementFee from './views/PropertyManagementFee.vue'





Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      children:[
        {
          path:'',
          component: Home
        },
        {
          path:'/home',
          name: 'home',
          component: Home
        },
        {
          path:'/userlist',
          name: 'userlist',
          component: UserList
        },
        {
          path: '/houselist',
          name: 'HouseList',
          component: HouseList,
          meta: {
            keepAlive: true // 使用缓存
  }
        },
        {
          path:'/tenantlist',
          name: 'tenantlist',
          component: TenantList
        },
        {
          path:'/leaseinfo',
          name: 'leaseinfo',
          component: LeaseInfo
        },
        {
          path:'/contractlist',
          name: 'contractlist',
          component: ContractList
        },
        {
          path:'/storeinformation',
          name: 'storeinformation',
          component: StoreInformation
        },
         {
          path:'/officecheckinlist',
          name: 'officecheckinlist',
          component: OfficeCheckinList
        },
        {
          path:'/propertyrepair',
          name: 'propertyrepair',
          component: PropertyRepairList
        },
        {
          path:'/propertycomplaint',
          name: 'propertycomplaint',
          component: PropertyComplaintList
        },
        {
          path:'/housingstatistics',
          name: 'housingstatistics',
          component: HousingStatistics
        },
        {
          path:'/propertymanagementfee',
          name: 'propertymanagementfee',
          component: PropertyManagementFee
        },
      ]
    },
    {
      path: '*',
      name: '/404',
      component:NotFound
    },
    {
      path: '/login',
      name: 'login',
      component:Login
    }
  ]
});

//路由守卫
router.beforeEach((to,from,next) => {
    const isLogin = getUser().token ? true : false;
  if(to.path == "/login" || to.path == "reguster"){
    next();
  }else{
    isLogin ? next() : next('login');
  }
})

export default router;
